<template>
  <div
    class="vertically-centered background-image scrollable"
    :style="{backgroundImage: `url(${bgImage})`}"
  >
    <div class="full-area padded vertically-centered desktop-wrapper scrollable">
      <div v-if="userProfile.fields">
        <el-row :gutter="0" class="results-header">
          <el-col :sm="10" :xs="24">
            <div class="icon-wrapper">
              <div
                class="avatar"
                :style="{backgroundImage: `url(${userProfile.fields.avatar.fields.file.url})`}"
              ></div>
            </div>
          </el-col>
          <el-col :sm="14" :xs="24" class="column">
            <div
              class="hide content-wrap"
              :class="{'bounce-entry': wellDone }"
            >
              <h4 class="sub">Tu perfil es:</h4>
              <h1>{{userProfile.fields.name}}</h1>
            </div>
            <h5
              class="hide sub gray-text"
              :class="{'bounce-entry': yourTime }"
              v-if="timeToCompletion"
            >Tu tiempo: {{timeToCompletion | msToMinutes}} minutos</h5>
          </el-col>
        </el-row>
        <div
          class="html-content hide" v-if="userProfile.fields.description" v-html="profileDescription"
          :class="{'bounce-entry': testResults }"
        ></div>
        <div
          class="html-content hide" v-if="userProfile.fields.extendedDescription" v-html="extendedDescription"
          :class="{'bounce-entry': testResults }"
        ></div>
        <div
          class="hide"
          :class="{'bounce-entry': testResults }"
        >
        </div>
        <el-row>
          <el-button
            class="hide continue-button"
            :class="{'delay-entry': restartButton }"
            type="danger"
            round
            @click="restartSurvey()"
          >Comenzar de nuevo</el-button>
        </el-row>
      </div>
    </div>  </div>
</template>

<script>
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

export default {
  props: [ 'bgImage' ],

  name: 'Profile',

  data () {
    return {
      wellDone: false,
      yourTime: false,
      testResults: false,
      restartButton: false
    }
  },

  computed: {
    weightedTestResults () {
      return this.$store.state.survey.weightedTestResults
    },
    showTestResults () {
      return this.$store.state.survey.showTestResults
    },
    profileDescription () {
      return documentToHtmlString(this.userProfile.fields.description)
    },
    extendedDescription () {
      return documentToHtmlString(this.userProfile.fields.extendedDescription)
    },
    pid () {
      return this.$route.params.pid
    },
    userProfileId () {
      return this.$store.state.user.profileId
    },
    userProfile () {
      return this.$store.state.user.profile
    },
    timeToCompletion () {
      if (this.$store.state.responses.length) {
        const arr = this.$store.state.responses
        return arr.reduce((accumulator, currentValue) => {
          return accumulator + currentValue.timeToCompletion
        }, 0)
      }
      return false
    }
  },

  methods: {
    restartSurvey () {
      this.$store.commit('CLEAR_FORM')
      this.$router.push({ name: 'survey', params: { sid: process.env.VUE_APP_DEFAULT_SID, qid: 0 } })
    },
    loadProfile (pid) {
      this.$store.dispatch('LOAD_PROFILE_BY_ID', { profileId: pid })
        .then(() => {
          this.$router.push({
            name: 'profile',
            pid: this.profileId
          })
        })
        .catch(err => {
          this.$router.push('/not-found')
          console.log(err)
        })
    }
  },

  filters: {
    msToMinutes: function (value) {
      const timeInSecs = Math.round(value / 100) / 10
      var mins = Math.floor(timeInSecs / 60)
      var secs = Math.floor(timeInSecs - mins * 60)
      return `${('00' + mins).slice(-2)}:${('00' + secs).slice(-2)}`
    }
  },

  mounted () {
    // If no pid provided, check if there's a profile in store
    if (!this.pid) {
      if (this.userProfileId) {
        this.loadProfile(this.userProfileId)
      } else {
        // No pid found, redirect to 404?
        this.$router.push('not-found')
      }
    } else {
      this.loadProfile(this.pid)
    }

    setTimeout(() => { this.wellDone = true }, 500)
    setTimeout(() => { this.yourTime = true }, 1000)
    setTimeout(() => { this.testResults = true }, 1500)
    setTimeout(() => { this.restartButton = true }, 5500)
  }
}
</script>

<style scoped lang="scss">
.avatar {
  width: 100%;
  height: 0;
  padding-bottom: 75%;
  background-size: cover;
  background-position: top center;
}

.icon-wrapper {

  @include breakpoint($micro) {
    margin-bottom: 20px;
  }
  @include breakpoint($tablet) {
    height: 330px;
    width: 300px;
    margin-bottom: 20px;
  }
  @include breakpoint($tablet) {
    height: 0;
    padding-bottom: 75%;
    width: 100%;
    margin-bottom: 20px;
    margin-left: 1em;
  }
}

.full-area {
  transition: all 0.2s ease-in-out;
  &.padded {
    padding-top: 0;
  }
}

.hide {
  opacity: 0;
  z-index: -1;
  position: relative;
}
.continue-button {
  margin-top: 20px;

  @include breakpoint($micro) {
    margin-top: 10px;
  }
}

h1 {
  color: $color-emphasis;
  margin-bottom: 0.2em;

  @include breakpoint($micro) {
    margin-bottom: 0;
  }
  @include breakpoint($desktop) {
    font-size: 1.8em;
  }
}

h3 {
  @include breakpoint($micro) {
    margin: 0;
  }
}

.results-header {
  @include breakpoint($desktop) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 1em;
    padding-top: 1em;
  }
}

h4.sub {
  margin-bottom: 0;
  @include breakpoint($desktop) {
    font-size: 1em;
    margin-top: 0;
  }
}

h5.sub {
  margin-bottom: 2em;
  margin-top: 0;
  @include breakpoint($desktop) {
    margin-bottom: 1em;
  }
}

.desktop-wrapper {
  @include breakpoint($desktop) {
    transform: scale(0.9);
    max-width: 800px;
  }
}

.background-image {
  background-size: cover;
}

.scrollable {
  max-height: unset;
}

.column {
  padding: 0 1em;
}
.html-content {
  padding: 0 1.4em 0.2em;
  text-align: left;

  @include breakpoint($tablet) {
    background: rgba($gray-light, 0.3);
    border-top: 1px solid $gray-light;
    border-bottom: 1px solid $gray-light;
    margin-top: 1em;
    margin-bottom: 1em;
    padding-top: 1.4em;
  }

  @include breakpoint($desktop) {
    font-size: 0.7em;
  }
}
.gray-text {
  color: $gray-medium;
  font-size: 0.7em;
}
</style>
